import { jsx as _jsx } from "react/jsx-runtime";
export const Card = ({ variant, className = '', children }) => {
    let borderColor = '';
    switch (variant) {
        case 'mtn':
            borderColor = 'border-mtn-gray-300';
            break;
        case 'mtd':
            borderColor = 'border-mtd-gray-200';
            break;
        case 'fg':
            borderColor = 'border-white';
            break;
        default:
            borderColor = '';
    }
    return _jsx("div", Object.assign({ className: `${className} border bg-white ${borderColor} rounded shadow-md` }, { children: children }));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FyZC5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJjb21wb25lbnRzL0NhcmQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFFQSxNQUFNLENBQUMsTUFBTSxJQUFJLEdBQThELENBQUMsRUFBRSxPQUFPLEVBQUUsU0FBUyxHQUFHLEVBQUUsRUFBRSxRQUFRLEVBQUUsRUFBRSxFQUFFO0lBQ3ZILElBQUksV0FBVyxHQUFHLEVBQUUsQ0FBQTtJQUNwQixRQUFRLE9BQU8sRUFBRTtRQUNmLEtBQUssS0FBSztZQUNSLFdBQVcsR0FBRyxxQkFBcUIsQ0FBQTtZQUNuQyxNQUFLO1FBQ1AsS0FBSyxLQUFLO1lBQ1IsV0FBVyxHQUFHLHFCQUFxQixDQUFBO1lBQ25DLE1BQUs7UUFDUCxLQUFLLElBQUk7WUFDUCxXQUFXLEdBQUcsY0FBYyxDQUFBO1lBQzVCLE1BQUs7UUFDUDtZQUNFLFdBQVcsR0FBRyxFQUFFLENBQUE7S0FDbkI7SUFDRCxPQUFPLDRCQUFLLFNBQVMsRUFBRSxHQUFHLFNBQVMsb0JBQW9CLFdBQVcsb0JBQW9CLGdCQUNuRixRQUFRLElBQ0wsQ0FBQTtBQUNSLENBQUMsQ0FBQSJ9